import EventBus from "@plugins/common/service/eventbus";

const modalEventBus = new EventBus();

export default modalEventBus;
